import {useChekinSDK} from 'context/ChekinSDK';
import {AUTH_INIT_MODELS} from '@chekin/core';
import HomeViewModals from 'components/HomeViewModals';
import {EndSessionButton} from 'components/sessions/EndSessionButton';
import {InstantCheckInGate} from 'pages/InstantCheckIn/InstantCheckInGate';
import {HomeContent} from './components/HomeContent';

function HomeView() {
  const {modelName} = useChekinSDK();

  const isUniversalLink = modelName === AUTH_INIT_MODELS.housing;

  if (isUniversalLink) {
    return null;
  }

  return (
    <InstantCheckInGate>
      <div className="home-view">
        <HomeContent />
        <HomeViewModals />
        <EndSessionButton />
      </div>
    </InstantCheckInGate>
  );
}

export {HomeView};
